import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { ClockOutlineIcon, CheckmarkIcon, ArchiveIcon } from 'components/common/Icons';

import styles from '../styles.module.scss';

export type StatusFilterType = 'watching' | 'accepted' | 'archive';

interface MobileStatusFiltersProps {
  activeStatusFilter: string | null;
  onStatusFilterChange: (status: StatusFilterType) => void;
  translationPrefix?: string;
}

const MobileStatusFilters: React.FC<MobileStatusFiltersProps> = ({
  activeStatusFilter,
  onStatusFilterChange,
  translationPrefix = 'freightSearch',
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.mobileStatusFilters}>
      <button
        type="button"
        className={cn(styles.mobileStatusBtn, {
          [styles.active]: activeStatusFilter === 'watching',
        })}
        onClick={() => onStatusFilterChange('watching')}
        title={t(`${translationPrefix}.statusWatching`)}
      >
        <ClockOutlineIcon />
      </button>
      <button
        type="button"
        className={cn(styles.mobileStatusBtn, {
          [styles.active]: activeStatusFilter === 'accepted',
        })}
        onClick={() => onStatusFilterChange('accepted')}
        title={t(`${translationPrefix}.statusAccepted`)}
      >
        <CheckmarkIcon />
      </button>
      <button
        type="button"
        className={cn(styles.mobileStatusBtn, {
          [styles.active]: activeStatusFilter === 'archive',
        })}
        onClick={() => onStatusFilterChange('archive')}
        title={t(`${translationPrefix}.statusArchive`)}
      >
        <ArchiveIcon />
      </button>
    </div>
  );
};

export default MobileStatusFilters;
